import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import lang from '../lang.json';

const Module4a1 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module4a1;

    const [musicPlaying, setMusicPlaying] = useState(false);
    const [audio, setAudio] = useState();
    const [musicTime, setMusicTime] = useState(0);

    useEffect(() => {
        let audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module4a.mp3");
        audio.pause()
        setAudio(audio);
    }, []);

    useEffect(() => {
        let time = musicTime;
        if (time > 0.1 && time <= 1.3) {
            let box1 = document.getElementById("box1"); //PB13
            box1.style.display = "block";
        } else {
            let box1 = document.getElementById("box1");
            box1.style.display = "none";
        }
        if (time > 2.8 && time <= 4.7) {
            let box2 = document.getElementById("box2");
            box2.style.display = "block";
        } else {
            let box2 = document.getElementById("box2");
            box2.style.display = "none";
        }
        if (time > 6 && time <= 10.5) {
            let box3 = document.getElementById("box3");
            box3.style.display = "block";
        } else {
            let box3 = document.getElementById("box3");
            box3.style.display = "none";
        }
        if (time > 11.8 && time <= 14.9) {
            let box4 = document.getElementById("box4");
            box4.style.display = "block";
        } else {
            let box4 = document.getElementById("box4");
            box4.style.display = "none";
        }
    }, [musicTime]);

    useEffect(() => {
        setInterval(() => {
            if (audio) {
                setMusicTime(audio.currentTime);
            }
        }, 30);
    }, [audio]);

    function play() {
        audio.play();
        setMusicPlaying(true);
    }

    function pause() {
        audio.pause();
        setMusicPlaying(false);
    }

    function reset() {
        audio.pause();
        audio.currentTime = 0;
        setMusicTime(0);
        setMusicPlaying(false);
    }

    useEffect(() => {
        var tl = anime.timeline({});
        tl.add({
            targets: '#circle1',
            r: 800,
            duration: 4200,
            easing: 'easeOutElastic(1, .8)',
        }, '0')
            .add({
                targets: '#img0',
                opacity: 0,
                duration: 2500,
                easing: 'linear',
            }, '1500')
            .add({
                targets: '#img2',
                opacity: 1,
                duration: 6000,
                easing: 'linear',
            }, '1000')
            .add({
                targets: '#img1',
                opacity: 1,
                duration: 3000,
                easing: 'linear',
            }, '1500')
            .add({
                targets: '.t1',
                opacity: 1,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, '1500')
    }, []);

    return (<>
        <div className="background" >
            <img src={process.env.PUBLIC_URL + "/assets/images/module4a1/1.jpg"}
                alt="image"
                id="img0"
                style={
                    { position: "absolute", left: 0, top: 0 }}
            />
            <img src={process.env.PUBLIC_URL + "/assets/images/module4a1/3.png"}
                alt="image"
                id="img2"
                style={
                    { position: "absolute", right: 0, top: 0, opacity: 0 }}
            />
            <img src={process.env.PUBLIC_URL + "/assets/images/module4a1/2.png"}
                alt="image"
                id="img1"
                style={
                    { position: "absolute", right: 0, top: 0, opacity: 0 }}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/module4a1/4.png"}
                alt="piano key"
                style={
                    { position: "absolute", left: 0, top: 305 }}
            />
            <img
                src={
                    !musicPlaying ? process.env.PUBLIC_URL + "/assets/images/piano/play.svg" : process.env.PUBLIC_URL + "/assets/images/piano/play_clicked.svg"
                }
                alt="play"
                onClick={play}
                style={{ position: 'absolute', left: '20px', top: 435, zIndex: 8 }} />

            <img
                src={
                    musicPlaying ? process.env.PUBLIC_URL + "/assets/images/piano/pause.svg" : process.env.PUBLIC_URL + "/assets/images/piano/pause_clicked.svg"
                }
                alt="pause"
                onClick={pause}
                style={{ position: 'absolute', left: '40px', top: 435, zIndex: 8 }} />

            <img
                src={process.env.PUBLIC_URL + "/assets/images/piano/back.svg"}
                alt="back"
                onClick={reset}
                style={{ position: 'absolute', left: '60px', top: 435, zIndex: 8 }} />

            <div
                id="box1"
                style={
                    {
                        position: "absolute",
                        left: 39,
                        top: 324,
                        width: 34,
                        height: 84,
                        backgroundColor: "rgb(255, 210, 31)",
                        opacity: 0.6
                    }}
            />

            <div
                id="box2"
                style={
                    {
                        position: "absolute",
                        left: 185,
                        top: 324,
                        width: 38,
                        height: 84,
                        backgroundColor: "rgb(255, 210, 31)",
                        opacity: 0.6
                    }}
            />

            <div
                id="box3"
                style={
                    {
                        position: "absolute",
                        left: 254,
                        top: 324,
                        width: 239,
                        height: 84,
                        backgroundColor: "rgb(255, 210, 31)",
                        opacity: 0.6
                    }}
            />

            <div
                id="box4"
                style={
                    {
                        position: "absolute",
                        left: 550,
                        top: 324,
                        width: 67,
                        height: 84,
                        backgroundColor: "rgb(255, 210, 31)",
                        opacity: 0.6
                    }}
            />

            <svg viewBox="0 0 660 500" >
                <mask id="circles"
                    maskUnits="objectBoundingBox" >
                    <rect x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="white" />
                    <circle id="circle1"
                        cx="40"
                        cy="80"
                        r="0"
                        fill="black" />
                </mask>

                <rect x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                />
            </svg>

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                className='t1'
                style={{
                    position: 'absolute',
                    left: 40,
                    top: 50,
                    textAlign: 'justify',
                    color: 'white',
                    fontSize: '15px',
                    width: 350,
                    zIndex: 15,
                    opacity: 0,
                }}
            >{texts.lang30}</p>
        </div>
    </>
    );
}
export default Module4a1;